var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"form-group",class:{ 'form-group--error': _vm.field.$error }},[_c('label',{class:_vm.labelClass,attrs:{"for":_vm.id}},[_vm._v(_vm._s(_vm.label))]),_vm._t("default"),_c('form-validation-invalid-feedback',{attrs:{"field":_vm.field,"text":_vm.text}})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }